export default {
  email: (str: string) => str.match(/^.+@.+\..+$/),
  username: (str: string) => str.match(/^[A-Za-z0-9._-]{3,50}$/), // Alphanumeric string that may include "_", "-" and "." having a length of 3 to 50 characters
  npi: (str: string) => str.match(/^[0-9\b]{10}$/),
  postalCode: (str: string) => str.match(/^[a-zA-Z0-9]+[-\s[a-zA-Z0-9]+$/),
  url: (str: string) =>
    str.match(
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&/=]*)/
    ),
  emoji:
    /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gm
};
